import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const BookingStatusRequest = {
  // Fetch a filtered list of booking statuses based on specific parameters
  bookingStatusFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getBookingStatusFilterSet}`, {
      withCredentials: true,
      params: {
        statusName: values?.statusName,
        isActive: values?.isActive,
      },
    }),

  // Fetch the list of all booking statuses
  bookingStatusList: () =>
    api.get(`${API_URL.BASEURL}${API_URL.getBookingStatusList}`, {
      withCredentials: true,
    }),

  // Fetch a single booking status by its ID
  getBookingStatusById: (bookingStatusId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getBookingStatusById}/${bookingStatusId}`, // Booking ID directly in the URL
      {
        withCredentials: true,
      }
    ),

  // Create a new booking status
  // createBookingStatus: (values) =>
  //   api.post(`${API_URL.BASEURL}${API_URL.createBooking}`, values, {
  //     withCredentials: true,
  //   }),

  // Update an existing booking status by ID
  updateBookingStatus: (bookingStatusId, values) =>
    api.put(
      `${API_URL.BASEURL}${API_URL.updateBookingStatus}/${bookingStatusId}`, // Send ID directly in the URL
      values,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json", // Ensure the request body is treated as JSON
        },
      }
    ),
};

export default BookingStatusRequest;
